<template>
	<div v-loading class="login" @click="close()">
		<div class="loginCon" @click.stop="">
			<img src="@/static/loginBack.png" class="back" />
			<div class="loginContainer">
				<div class="title">
					准聘
				</div>
				<div style="margin-bottom: 33px;">
					<div class="phone inputCon">
						<div class="prefix">
							<div>
								+86
							</div>
							<img src="@/static/pull.png" class="icon" />
						</div>
						<input type="text" v-model='phone' class="input" placeholder="手机号" maxlength="11"
							@focus="phoneStatus=0" />
					</div>
					<div v-if="phoneStatus!=0" class="red">
						{{phoneStatus==1?'请输入手机号':'请输入正确手机号'}}
					</div>
				</div>
				<div style="margin-bottom: 33px;">
					<div class="code inputCon">
						<input type="text" v-model="code" class="input" @focus="codeStatus=0" />
						<div v-if="timer > 0" class="gary">{{ timer }} 秒后重发</div>
						<div v-else class="codeText" @click="sendCode()">
							发送验证码
						</div>
					</div>
					<div v-if="codeStatus!=0" class="red">
						{{codeStatus==1?'请输入验证码':'请输入正确验证码'}}
					</div>
				</div>
				<div class="button" @click="login()">
					登录/注册
				</div>
				<div class="agreement">
					继续登录即表示您同意准聘<span @click="toAgreement(2)">《准聘用户协议》</span><span @click="toAgreement(3)">《个人信息保护政策》</span>
				</div>
			</div>
			<img src="@/static/close.png" class="close" @click="close()" />
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				timer: 0,
				intervalId: null, // 保存计时器的ID
				phoneStatus: 0, //1手机号未输入 2手机号不正确
				codeStatus: 0, //1验证码未输入 2验证码不正确
				phone: '',
				code: '',
				loading: false
			}
		},
		created() {
			document.body.style.overflow = 'hidden';
		},
		beforeDestroy() {
			document.body.style.overflow = 'visible';
			this.stopTimer(); // 在组件销毁前清除计时器
		},
		methods: {
			toAgreement(type){
				this.$router.push({ name: 'agreement',query:{type:type} });
				this.close()
			},
			startTimer() {
				console.log('计时器启动')
				this.timer = 60; // 设置初始时间
				this.intervalId = setInterval(() => {
					if (this.timer > 0) {
						this.timer--;
					} else {
						this.stopTimer();
					}
				}, 1000);
			},
			stopTimer() {
				clearInterval(this.intervalId);
				this.intervalId = null;
			},
			close() {
				this.$store.commit('changeLoginDialog', false);
			},
			sendCode() {
				const regex = /^1[3456789]\d{9}$/;
				if (this.phone == '') {
					this.phoneStatus = 1
					return
				}
				if (!regex.test(this.phone)) {
					this.phoneStatus = 2
					return
				}
				let data = {
					phone: this.phone
				}
				this.$axios.post('/api/client/Common/getSmsCode', data).then(res => {
					if (res.code == 200) {
						this.startTimer()
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			login() {

				if (this.code == '') {
					this.codeStatus = 1
					return
				}
				this.loading = true
				let data = {
					phone: this.phone,
					sms_code: this.code,
					auth_mthod: 'pc'
				}
				this.$axios.post('/api/client/Auth/login', data).then(res => {
					if (res.code == 200) {
						this.$util.setStorage('token', res.data.token)
						this.$store.commit('changeToken', res.data.token)
						this.$util.setStorage('userinfo', res.data.user)
						this.$store.commit('changeinfo', res.data.user)
						this.$util.setStorage('user_im_sign', res.data.user_im_sign)
						this.$util.setStorage('en_im_sign', res.data.en_im_sign)
						// this.getinfo()
						this.TimLogin(res.data.user)
					} else {
						this.loading = false
						this.$eltips(res.msg, 'error')
					}
				})
			},
			TimLogin(userinfo){
				let userID,userSig;
				if(userinfo.type=='1'){
					userID = userinfo.en_im_account
					userSig = this.$util.getStorage('en_im_sign')
				}else{
					userID = userinfo.user_im_account
					userSig = this.$util.getStorage('user_im_sign')
				}
				this.tim.login({userID:userID,userSig:userSig}).then((res) => {
					console.log('腾讯IM登录成功------',res)
					if(userinfo.type=='1'){
						this.getCompanyCount()
						this.$store.commit('changeStanding', 'company')
						this.$router.push({ name: 'fierce'});
					}else{
						this.getUserCount()
						this.$store.commit('changeStanding', 'user')
					}
					this.$store.commit('changeLoginDialog', false)
				}).catch((err) => {
					console.error('腾讯云即时通讯登录失败------',err)
					this.$util.restLogin()
					this.$util.setErrLog('腾讯云登录错误',err)
					this.$eltips('登录失败','error')
				})
			},
			getinfo() {
				this.$axios.get('/api/client/User/info').then(res => {
					this.loading = false
					if (res.code == 200) {
						this.$util.setStorage('userinfo', res.data)
						this.$store.commit('changeinfo', res.data)
						this.$store.commit('changeLoginDialog', false)
						// 根据点击的按钮来切换身份
						if (this.$store.state.isLogin == 2) {
							this.judgRequest()
						}else{
							this.toggleRequest(1)
						}
						
						this.$message({
							message: '登录成功',
							type: 'success'
						});
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			judgRequest() {
				this.loading = true
				this.$axios.get('/api/client/ES/getCompanyData').then(res => {
					this.loading = false
					if (res.code == 500) { //未获取企业信息->新建企业
					    this.$router.push({ name: 'setBusiness',query:{type:1}})
					} else if (res.code == 205) { //申请加入某企业，还在审核中
						this.$alert('请耐心等待', '资料审核中', {confirmButtonText: '确定'});
					} else if (res.code == 206) { //新创建企业，还在审核中
					    this.$alert('请耐心等待', '资料审核中', {confirmButtonText: '确定'});
					} else if (res.code == 200) { //获取到企业信息，进行下一步
					    this.toggleRequest(2)
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			getUserCount(){
				this.$axios.get('/api/client/User/getUserPersonalCenterStatistics').then(res=>{
					if(res.code==200){
						const obj = {
							invite:res.data.Interview_count2,
							wait:res.data.Interview_count4
						}
						this.$store.commit('changeInterviewPending',obj)
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			getCompanyCount(){
				this.$axios.get('/api/client/ES/getEnPersonalCenterStatistics').then(res=>{
					if(res.code==200){
						this.$store.commit('changeDeliverPending', res.data.Tobe_invited_count)
						this.$store.commit('changeJoinPending', res.data.totalCompanyJoinApply)
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			// 切换身份
			toggleRequest(type){
				this.$axios.post('/api/client/User/SwitchIdentities',{type:type}).then(res => {
					if (res.code == 200) {
						if(type==1){
							this.getUserCount()
							this.$store.commit('changeStanding', 'user')
						}else{
							this.getCompanyCount()
							this.$store.commit('changeStanding', 'company')
							this.$router.push({ name: 'fierce'});
						}
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.login {
		width: 100%;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.5);
		position: fixed;
		z-index: 999;
		top: 0;
		left: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.loginCon {
		width: 559px;
		height: 520px;
		position: relative;
		padding: 85px 0 48px;
		box-sizing: border-box;
		background: #FFF;
		border-radius: 32px;
		.back {
			width: 559px;
			height: 520px;
			position: absolute;
			top: 0;
			left: 0;
		}

		.close {
			position: absolute;
			z-index: 2;
			right: 28px;
			top: 28px;
			cursor: pointer;
		}

		.loginContainer {
			position: relative;
			z-index: 2;
			display: flex;
			align-items: center;
			// justify-content: space-between;
			height: 100%;
			flex-direction: column;

			.title {
				color: #51A190;
				font-size: 34px;
				font-weight: bold;
				margin-bottom: 55px;
			}

			.red {
				color: red;
				margin-top: 10px;
				font-size: 14px;
			}

			.inputCon {
				padding: 15px 28px 15px 22px;
				border: 1px solid #A3A7B3;
				border-radius: 16px;
				display: flex;
				align-items: center;
				font-size: 18px;
				width: 413px;
				box-sizing: border-box;

				input {
					&::placeholder {
						/* Chrome, Firefox, Opera, Safari 10.1+ */
						color: #A3A7B3;
					}

					border: none;
					outline: none;
				}

				.input {
					flex: 1;
					font-size: 18px;
				}
			}

			.phone {
				.prefix {
					display: flex;
					align-items: center;

					.icon {
						margin-left: 26px;
						width: 10px;
						height: 10px;
					}
				}

				.input {
					margin-left: 14px;
				}
			}

			.code {
				.codeText {
					color: #51A190;
					cursor: pointer;
				}

				.gary {
					color: #666;
				}

				.input {
					margin-right: 14px;
				}
			}

			.button {
				margin-bottom: 32px;
				width: 413px;
				line-height: 56px;
				background-color: #51A190;
				color: #fff;
				border-radius: 16px;
				font-size: 16px;
				text-align: center;
				cursor: pointer;
			}

			.agreement {
				color: #A3A7B3;
				font-size: 14px;
				span {
					cursor: pointer;
					color: #51A190;
				}
			}
		}

	}
</style>